<div class="delete-modal">
  <sync-dialog [config]="{
      title: 'Delete',
      subTitle: subTitle,
      isClosable: false,
      actionButton: !batchView.spinner ? 'Delete' : '',
      cancelButton: 'Cancel',
      onActionClick: onDelete,
      onCancelClick: onCancelClick}" [open]="showDialog" [onClose]="closeDialog" [isCritical]="true">
    <div class="delete-modal-container">
      <sync-alert *ngIf="batchView.spinner" type="warning" [showLeadIcon]="true" leadIcon="warning"
                title="Do not close this window or your web browser."
                description="Please wait until the operation has completed successfully." [showActions]="false"
                [showPrimaryAction]="false" [showSecondaryAction]="false" [showCloseButton]="false"></sync-alert>
            <sync-spinner *ngIf="batchView.spinner"></sync-spinner>
            <ng-container *ngIf="!batchView.spinner">
              <ng-container *ngIf="deleteItems.length === 1">
                  <span>Are you sure you want to delete this item? It will be permanently deleted after {{purgeLimit}} days.</span>

                  <span *ngIf="isDeletingSharedFolder()">
                    Other members will still be able to view and use this folder. It will only be deleted for you.
                  </span>
              </ng-container>
              <ng-container *ngIf="deleteItems.length > 1">
                  <span>Are you sure you want to delete these items? They will be permanently deleted after {{purgeLimit}} days.</span>

                  <span *ngIf="isDeletingSharedFolder()">
                    Other members will still be able to view and use the shared folder. It will only be deleted for you.
                  </span>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="batchView.spinner">
              <ng-container *ngFor="let item of deleteItems
              | orderBy: '[type,search_name]':false">
                  <div *ngIf="batchView.spinner === item.sync_id" class="processing body-bold-1">
                      Processing {{ item.name }} - {{ batchView.percent }}%
                  </div>
              </ng-container>
          </ng-container>
    </div>
  </sync-dialog>
</div>